import { css } from "lit";
import constants from "../../constants";

export const style = css`
	:host {
		padding: ${constants.FILTER_PADDING}px;
		display: flex;
		flex-direction: column;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	.body og-container, .body og-container rp-filter {
		height: 100%;
	}

	.row, .controls {
		margin-bottom: ${constants.FILTER_PADDING}px;
	}

	.row og-tree-dropdown {
		flex: 1;
		border: 1px solid var(--og-colortype-accent-border-color);
		background-color: var(--og-accent-color-alpha-30);
		color: var(--og-text-color-3);
	}

	.controls {
		flex: 0 0 22px;
		display: flex;
		flex-direction: row;
	}

	.controls og-button {
		height: 100%;
		text-align: center;
		display: block;
		border-right: none;
		width: 20px;
	}

	.controls og-button.btn-primary {
		flex: 1;
	}

	.controls og-button.btn-secondary {
		flex: 0 0 19px;
		border-radius: 0;
	}

	.controls og-dropdown-menu {
		flex: 0 0 19px;
	}
`;
